import React from 'react'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { Box, IconButton, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { useSelector } from 'react-redux';
import Preloading from '../Pages/Preload/Preloading';
import CloseIcon from '@mui/icons-material/Close';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function PopupForm(props) {
  const maintheme = useSelector((state) => state.themeData.maintheme);
  const globalLoading = useSelector(state => state.settingsData.globalLoading)

  const handleClose = () => {
    props.setOpen(false);
  };

  return (
    <Dialog
      open={props?.open}
      TransitionComponent={Transition}
      keepMounted
      onClose={props?.notClose ? null : handleClose}
      aria-describedby="alert-dialog-slide-description"
      maxWidth={props?.maxWidth || "md"}
      fullWidth
      fullScreen={props?.isFullScreen ? true : false}
      PaperProps={{
        sx: {
          borderRadius: props?.isFullScreen ? '0' : '16px',
          overflow: 'hidden',
          boxShadow: '0 24px 48px rgba(0, 0, 0, 0.15)',
          minHeight: props?.isFullScreen ? '100%' : props?.customeHeight ? props?.customeHeight : '400px',
          maxWidth: props?.isFullScreen ? '100%' : props?.customWidth ? props?.customWidth : undefined,
        }
      }}
      BackdropProps={{
        sx: {
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          backdropFilter: 'blur(4px)',
        }
      }}
    >
      {!props?.loading ? (
        <>
          {/* Modern Header */}
          <DialogTitle
            sx={{
              background: `linear-gradient(135deg, ${maintheme?.primary} 0%, ${maintheme?.secondary || maintheme?.primary} 100%)`,
              color: '#fff',
              padding: '16px 24px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'relative',
            }}
          >
            <Box sx={{ flex: 1 }} />
            <Box
              sx={{
                flex: 10,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontFamily: 'Cairo-Bold',
                  fontSize: '20px',
                  fontWeight: 700,
                  letterSpacing: '0.5px',
                }}
              >
                {props?.title}
              </Typography>
              {props?.hasSubTitle && (
                <Typography
                  sx={{
                    fontFamily: 'Cairo',
                    fontSize: '13px',
                    opacity: 0.9,
                    marginTop: '4px',
                  }}
                >
                  {props?.subTitle}
                </Typography>
              )}
            </Box>
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
              }}
            >
              {props?.hasIconheader ? (
                props?.iconHeader
              ) : (
                <IconButton
                  onClick={handleClose}
                  sx={{
                    color: '#fff',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 0.2)',
                    },
                    transition: 'all 0.2s ease',
                  }}
                >
                  <CloseIcon />
                </IconButton>
              )}
            </Box>
          </DialogTitle>

          {/* Content */}
          <DialogContent
            sx={{
              padding: '24px',
              backgroundColor: '#fafafa',
              overflowY: 'auto',
              '&::-webkit-scrollbar': {
                width: '6px',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: 'rgba(0, 0, 0, 0.05)',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: 'rgba(0, 0, 0, 0.15)',
                borderRadius: '3px',
              },
            }}
          >
            {globalLoading && <Preloading dashboardMode={true} />}
            <Box sx={{ paddingTop: '16px' }}>
              {props?.content}
            </Box>
          </DialogContent>

          {/* Footer */}
          <DialogActions
            sx={{
              padding: '16px 24px',
              backgroundColor: '#fff',
              borderTop: '1px solid rgba(0, 0, 0, 0.06)',
              gap: '12px',
            }}
          >
            {props?.footer}
          </DialogActions>
        </>
      ) : (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            minHeight: '300px',
          }}
        >
          <CircularProgress
            size={50}
            sx={{
              color: maintheme?.primary || '#5e99f7',
            }}
          />
        </Box>
      )}
    </Dialog>
  );
}
